import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IContentTileExpectedObj } from 'ui-ng-content-tile';
import { IDatasource, Query } from 'utility-ts-orm';
import { HoldsAttentionServant } from '../servants/holds_attention_servant';
import { Hold } from './../builders/holds_builder';
import { HoldsConfigService } from './../servants/holds_config_servant';

export class HoldListQuery implements IQuery {
  private _result: {
    needsAttention: IContentTileExpectedObj[];
    holds: IContentTileExpectedObj[];
    pastHolds: IContentTileExpectedObj[];
  };

  constructor(private ngHoldDatastore: IDatasource<Hold>, private holdsConfigService: HoldsConfigService) {
    Query.registerQuery(this, this.ngHoldDatastore);
  }

  _priorityFeedObjectBuilder(hold: Hold): IContentTileExpectedObj {
    const title = hold.name;
    const icon = HoldsAttentionServant.getHoldIcon(hold);
    const action = HoldsAttentionServant.getHoldRoutingDetails(hold, this.holdsConfigService);
    return {
      icon,
      action,
      text: { title, subTitle: '' },
      isOverdue: false,
      isActive: true
    };
  }

  run(): this {
    this._result = {
      needsAttention: _4.map(
        this.ngHoldDatastore.query((hold: Hold) => HoldsAttentionServant.isHoldThatRequiresAttention(hold)),
        (hold: Hold) => this._priorityFeedObjectBuilder(hold)
      ),
      holds: _4.map(
        this.ngHoldDatastore.query((hold: Hold) => HoldsAttentionServant.isRegularHold(hold)),
        (hold: Hold) => this._priorityFeedObjectBuilder(hold)
      ),
      pastHolds: _4.map(
        this.ngHoldDatastore.query((hold: Hold) => HoldsAttentionServant.isPastHold(hold)),
        (hold: Hold) => this._priorityFeedObjectBuilder(hold)
      )
    };
    return this;
  }

  hasHolds(): boolean {
    return !_4.isEmpty(_4.get(this._result, 'needsAttention', [])) || !_4.isEmpty(_4.get(this._result, 'holds', []));
  }

  get result() {
    return this._result;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-holds/src/queries/holds_list_query.ts